import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { HorizontalAlignmentEnum, VerticalAlignmentEnum } from '@repo/ui/src/enums/shared-enums';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ImageProps, ToutContentProps } from '@repo/ui/src/types';
import { imageFullWidthXs } from '@repo/ui/src/styles/variables';
import { classNames } from '@repo/ui/src/utils/classNames';
import Image from '@repo/ui/src/components/Image/New';

export interface FullWidthCardProps {
  toutContent: ToutContentProps;
  image: ImageProps;
  horizontalAlignment?: HorizontalAlignmentEnum;
  verticalAlignment?: VerticalAlignmentEnum;
  backgroundImageUrl: string;
  buttonNegative?: boolean;
  isVideo?: any;
  _testID?: string;
  index?: number;
  onClick?: () => void;
}
const fullVerticalAlignmentClasses = {
  [VerticalAlignmentEnum.Top]: 'tw-items-start',
  [VerticalAlignmentEnum.Center]: 'tw-items-center',
  [VerticalAlignmentEnum.Bottom]: 'tw-items-end',
};
const fullHorizontalAlignmentClasses = {
  [HorizontalAlignmentEnum.Left]: 'tw-justify-start',
  [HorizontalAlignmentEnum.Center]: 'tw-justify-center',
  // padding should only be on the right side
  [HorizontalAlignmentEnum.Right]: 'tw-justify-end md:tw-pr-40',
};

const FullWidthCard = ({
  toutContent,
  image,
  horizontalAlignment,
  verticalAlignment,
  onClick,
  backgroundImageUrl,
  buttonNegative = false,
  isVideo,
  _testID,
  index,
}: FullWidthCardProps) => {
  const imageUrl = buildImageSrc(image, imageFullWidthXs, 1, 1);

  return (
    <div
      className={classNames(
        'tw-relative tw-grid tw-bg-cover tw-bg-no-repeat tw-bg-center',
        !isVideo && 'tw-bg-black',
        toutContent?.youtubeLink && 'tw-cursor-pointer',
      )}
      onClick={onClick}
      style={{
        backgroundImage: backgroundImageUrl ? `url("${backgroundImageUrl}")` : 'none',
      }}
      data-test-id={`full_width_card_${_testID}${index}`}
    >
      <div
        className={classNames(
          'tw-flex tw-flex-col tw-relative',
          horizontalAlignment === HorizontalAlignmentEnum.Left
            ? 'sm:tw-flex-row-reverse'
            : 'sm:tw-flex-row',
          horizontalAlignment === HorizontalAlignmentEnum.Left && 'tw-bg-gradient-to-l',
          horizontalAlignment === HorizontalAlignmentEnum.Right && 'tw-bg-gradient-to-r',
          horizontalAlignment === HorizontalAlignmentEnum.Center
            ? 'tw-bg-[rgba(0,0,0,0.6)]'
            : 'tw-from-transparent tw-via-50% tw-via-[rgba(0,0,0,0.6)] tw-to-[rgba(0,0,0,0.6)]',
        )}
      >
        {image?.image && horizontalAlignment !== HorizontalAlignmentEnum.Center && (
          <div className="tw-flex-1 tw-h-auto tw-justify-center tw-items-center tw-hidden sm:tw-flex">
            {image?.image && (
              <Image
                src={imageUrl}
                alt={image.image.name!}
                className="tw-pt-6 sm:tw-pt-0 tw-w-[70%] sm:tw-w-1/2"
              />
            )}
          </div>
        )}
        <div></div>
        <div
          className={classNames(
            'tw-flex tw-flex-1 tw-h-auto',
            horizontalAlignment
              ? fullHorizontalAlignmentClasses[horizontalAlignment]
              : fullHorizontalAlignmentClasses[HorizontalAlignmentEnum.Center],
            verticalAlignment
              ? fullVerticalAlignmentClasses[verticalAlignment]
              : fullVerticalAlignmentClasses[VerticalAlignmentEnum.Center],
          )}
        >
          <ToutContent
            dark
            headingStyleVariant="h2"
            divider={!!toutContent.description}
            {...toutContent}
            buttonNegative={buttonNegative}
            className="sm:tw-max-w-[75%] md:tw-max-w-[50%] tw-p-6 tw-z-10 sm:[&_p]:tw-line-clamp-4 [&_button]:tw-mt-4 sm:tw-p-gutterLG lg:tw-max-w-[80%]"
          />
        </div>
      </div>
    </div>
  );
};

export default FullWidthCard;
